'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isInDateRange = exports.isFutureDate = exports.isPastDate = exports.isToday = undefined;

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isToday = exports.isToday = function isToday(date) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)();
  return now.isSame((0, _moment2.default)(date), 'day');
};

var isPastDate = exports.isPastDate = function isPastDate(date) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)();
  return now.isAfter((0, _moment2.default)(date), 'day');
};

var isFutureDate = exports.isFutureDate = function isFutureDate(date) {
  var now = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _moment2.default)();
  return now.isBefore((0, _moment2.default)(date), 'day');
};

var isInDateRange = exports.isInDateRange = function isInDateRange(startDate, endDate) {
  return function (date) {
    return (0, _moment2.default)(date).isBetween((0, _moment2.default)(startDate), (0, _moment2.default)(endDate), 'day', '[]');
  };
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/clark-utils/lib/dates/index.js
// module id = 581
// module chunks = 0